import { MutationKey } from '@tanstack/react-query';

const base: MutationKey = ['password'];

export const forgotPassMutationKeys = {
  baseKey: base,
  sendEmail: [...base, 'sendEmail'],
  resetPassword: [...base, 'resetPassword'],
};